// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import './PayoutDetails.less';
import InfoCard from '../Card/InfoCard';
import {processTranslation} from '../utils/commonUtil';

class PayoutDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getBankingCountryListItems = (bankingCountryList) => {
        const countries = bankingCountryList && bankingCountryList.length > 0 ?
            bankingCountryList.map((e) => ({
                label: e.countryName,
                value: e.countryCode
            })) : [];
        countries.unshift('');
        return countries;
    }

    getBankingStateListItems = (bankingCountry) => {
        const states = bankingCountry?.states || [];
        const bankingStateList = states.map((entry) => {
            return {
                value: entry,
                label: entry
            };
        });
        bankingStateList.unshift('');
        return bankingStateList;
    }

    render() {
        const {
            translations,

            currency,

            // bankingCountryList, // TODO: commenting out for now because not used atm and eslint will complain, but will be used for validation in later stories
            bankingCountry,
            countryList,
            bankingCountryCode,
            bankingCountryCodeError,
            handleBankingCountryChange,
            handleBankingCountryOnBlur,

            showBankingState,
            bankingState,
            bankingStateError,
            handleBankingStateChange,
            handleBankingStateOnBlur,

            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            enableBackButton,
            handleFormSubmit,
        } = this.props;
        return (
            <div id="payout-details" className="payout-details">
                <div className="payout-details-container">
                        <div className="form-col">
                            {(serviceError) ? (
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                            ) : null}

                            <div className="wrapper">
                                <div className="content-col-text panel-head">
                                    <h1 className="head">{translations['ipmob.payout_details.heading_1']}</h1>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-text head">
                                    {/* eslint-disable-next-line react/no-danger */}
                                    <div className="desc" dangerouslySetInnerHTML={{ __html: translations['ipmob.payout_details.heading_1.desc']}} />
                                </div>
                            </div>
                            <form role="form" onSubmit={handleFormSubmit}>

                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col-text sub-head">
                                            <h3>
                                                {processTranslation(
                                                    translations['ipmob.payout_details.sub_heading_1'],
                                                    [currency ? translations[`ipmob.brand_determination.currency.${currency}`] : '']
                                                )}
                                            </h3>
                                        </div>
                                    </div>

                                    <div className="wrapper">
                                        <div className="content-col-text sub-head country-head">
                                            <h3>{translations['ipmob.payout_details.sub_heading_2']}</h3>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingCountry"
                                                name="Banking Country selected"
                                                items={this.getBankingCountryListItems(countryList)}
                                                label={translations['ipmob.mailing_address.label_1']}
                                                value={bankingCountryCode}
                                                onChange={handleBankingCountryChange}
                                                errorMsg={translations[bankingCountryCodeError]}
                                                onBlur={handleBankingCountryOnBlur}
                                            />
                                        </div>
                                    </div>

                                    {showBankingState && <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingState"
                                                name="Banking State selected"
                                                items={this.getBankingStateListItems(bankingCountry)}
                                                label={translations['ipmob.mailing_address.label_5']}
                                                value={bankingState}
                                                onChange={handleBankingStateChange}
                                                errorMsg={translations[bankingStateError]}
                                                onBlur={handleBankingStateOnBlur}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                <ContinueButtonHolder
                                    enableContinueButton={enableContinueButton}
                                    handleContinueButtonClick={handleFormSubmit}
                                    translations={translations}
                                    enableBackButton={enableBackButton}
                                    continueButtonId={'payoutDetailsContinueBtn'}
                                />
                            </form>
                        </div>

                        <div className="spacer-col"/>

                        <div className="content-col info-card-col">
                            <InfoCard className="payout-details-info-card">
                                <h2 className="info-card-header">{translations['ipmob.payout_details.info.heading_1']}</h2>
                                {/* eslint-disable-next-line react/no-danger */}
                                <p className="info-card-text" dangerouslySetInnerHTML={{ __html: translations['ipmob.payout_details.info.heading_1.desc']}} />
                            </InfoCard>
                        </div>
                </div>
            </div>
        );
    }
}

export default PayoutDetails;
